module.exports = __webpack_public_path__ + "img/03-2-2区域运营.02fde40d.svg";